import { apiFetch } from '@/lib/api-client';
import type { AdminUserItem } from '@uniticket/shared';

// API client for the reduced admin user-management surface (Admin only).

export interface AdminUserListResponse {
  data: AdminUserItem[];
  meta: { total: number; limit: number; offset: number };
}
export interface CreateUserResponse { user: AdminUserItem; activationUrl: string | null; }
export interface UpdateUserResponse { user: AdminUserItem; }
export interface ResendInviteResponse { activationUrl: string; }

export interface AdminUserFilters {
  role?: string;
  isActive?: 'true' | 'false';
  search?: string;
  limit?: number;
  offset?: number;
}

export function fetchAdminUsers(filters: AdminUserFilters = {}): Promise<AdminUserListResponse> {
  const qs = new URLSearchParams();
  if (filters.role) qs.set('role', filters.role);
  if (filters.isActive) qs.set('isActive', filters.isActive);
  if (filters.search) qs.set('search', filters.search);
  if (filters.limit != null) qs.set('limit', String(filters.limit));
  if (filters.offset != null) qs.set('offset', String(filters.offset));
  const q = qs.toString();
  return apiFetch<AdminUserListResponse>(`/admin/users${q ? `?${q}` : ''}`);
}

export function createUser(body: {
  email: string;
  displayName: string;
  role: string;
  authType?: string;
}): Promise<CreateUserResponse> {
  return apiFetch<CreateUserResponse>('/admin/users', { method: 'POST', body: JSON.stringify(body) });
}

export function updateUser(id: string, body: {
  displayName?: string;
  role?: string;
  isActive?: boolean;
}): Promise<UpdateUserResponse> {
  return apiFetch<UpdateUserResponse>(`/admin/users/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export function resendInvite(id: string): Promise<ResendInviteResponse> {
  return apiFetch<ResendInviteResponse>(`/admin/users/${id}/resend-invite`, { method: 'POST' });
}
